module.exports = __webpack_public_path__ + "img/16.8faf94e4.png";